export const ENV = process.env.REACT_APP_ENV;
export const VERSION = process.env.REACT_APP_VERSION;

export const MOCKEND_ALL_DISABLED =
  process.env.REACT_APP_MOCKEND_ALL_DISABLED === "true";
export const MOCKEND_ALL_ENABLED =
  process.env.REACT_APP_MOCKEND_ALL_ENABLED === "true";
export const MOCKEND_TIMING = 800;

export const TOKEN_PATH = process.env.REACT_APP_TOKEN_PATH || "";

export const API_NAME = process.env.REACT_APP_API_NAME || "";
export const ENDPOINT = process.env.REACT_APP_ENDPOINT;
export const REGION = process.env.REACT_APP_REGION;

export const MAX_DATA_ENTRY_STEP = 5;
export const MAX_WITNESS_NUMBER = 5;
export const TEXTAREA_MAX_LENGTH = 4000;
export const MAX_FILE_SIZE_MB = 10;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const ACCEPTED_FILE_TYPES = ".pdf,.docx,image/*";

export const COGNITO_ID_TOKEN_KEY = "CAI_IdToken";
export const ITAS_AR_TOKEN_KEY = "CAI_ITAS_AR_TOKEN";
export const ITAS_AR_PROCLIE_KEY = "CAI_ITAS_AR_PROCLIE";
export const AR_LINK = process.env.REACT_APP_AR_LINK || "";
